<template>
    <div id="top_menu">
        <ul>
            <li v-for="(item, index) in menuItems"
                :key="item.text"
                @mouseleave="hovering = -1"
                @mouseenter="hovering = index"
                @click.prevent="handleClick(index)"
                :class="{ hover: hovering === index, active: active === index }"
            ><a :href="item.path">{{item.text}}</a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "TopMenu",
        components: {

        },
        data () {
            return {
                menuItems: [
                    { text: 'Home', name: 'Home', path: '/' },
                    { 
                        text: 'About',
                        name: 'Home',
                        hash: '#about',
                        path: '/#about'
                    },
                    { text: 'My Journey', name: 'HireMe', path: '/portfolio' },
                    { text: 'Blog/Projects', name: 'Blog', path: '/writing' }
                ],
                hovering: -1,
                active: -1
            } 
        },
        computed: {

        },
        methods: {
            handleClick (index) {
                const prev = this.active
                this.active = index
                const item = this.menuItems[index]
                const itemPrev = this.menuItems[prev]
                if (itemPrev && itemPrev.name === 'Home' && !itemPrev.hash &&
                    item.name === 'Home' && item.hash === '#about') {
                    this.$router.replace({ hash: '#about', params: { noscroll: false } })
                } else if (itemPrev && itemPrev.name === 'Home' && itemPrev.hash === '#about' &&
                    item.name === 'Home' && !item.hash) {
                    this.$router.replace({ hash: null, params: { noscroll: false } })
                } else {
                    this.$router.push({ name: item.name, hash: item.hash })
                }
            },
        },
        watch: {
            $route (to, from) {
                if (to.name === 'Home' && to.hash === '#about') {
                    this.active = 1
                } else if (to.name === 'Home' && !to.hash) {
                    this.active = 0
                } else {
                    this.active = this.menuItems.findIndex(item => item.name === to.name)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/variables";
    #top_menu {
        background: white;
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: 50px;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);

        > ul {
            padding-left: 0;
            list-style-type: none;
            display: flex;
            margin: 0;
            height: 100%;
            align-items: center;
            
            > li {
                position: relative;
                display: inline-block;
                margin: 0 10px;
                cursor: pointer;
                outline: none;

                a {
                    color: inherit;
                    text-decoration: none;
                }

                &::after {
                    content: "";
                    width: 0%;
                    position: absolute;
                    z-index: -1;
                    bottom: -2px;
                    left: 50%;
                    height: 2px;
                    background-color: $blue;
                    transition: all 400ms ease;
                }

                &.active::after {
                    width: 100%;
                    left: 0;
                    background-color: $green;
                }

                &.hover::after {
                    width: 100%;
                    left: 0%;
                }
            }
        }
    }
</style>